import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p3 from '../assets/images/soft1.gif';


const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b>Just Click on a Software site to enjoy...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p3} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://filehippo.com/" className="btn btn-xl btn-light mr-4">
         Filehippo
        </a>

        <a href="http://softfamous.com/" className="btn btn-xl btn-dark">
          Softfamous
        </a>
                

        <a href="https://software.informer.com/" className="btn btn-xl btn-light">
          Software. Informer
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://filehorse.com/" className="btn btn-xl btn-light mr-4">
         Filehorse
        </a>
        <a href="https://en.uptodown.com/" className="btn btn-xl btn-dark">
          Uptodown downloads
        </a>

<a href="https://getintopc.com/" className="btn btn-xl btn-light mr-4">
          GET INTO PC
        </a>

      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://freewarefiles.com/" className="btn btn-xl btn-light mr-4">
          Freeware
        </a>
        <a href="http://www.bytesin.com/" className="btn btn-xl btn-dark">
          Soft32
        </a>
      </div>
    </section>

<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://play.google.com/store/apps?utm_source=emea_Med&utm_medium=hasem&utm_content=Oct2020&utm_campaign=Evergreen&pcampaignid=MKT-EDR-emea-gh-1001280-Med-hasem-py-Evergreen-Oct2020-Text_Search_BKWS%7CONSEM_kwid_43700008633190267&gclid=CjwKCAjwx6WDBhBQEiwA_dP8rX_s5CGOo-G3-apOVWk5ngk72j6-e-Wnk8Hq6PJ7dAND65OsXHBENRoCtKoQAvD_BwE&gclsrc=aw.ds" className="btn btn-xl btn-light mr-4">
          Play Store
        </a>
        <a href="https://www.apple.com/app-store/" className="btn btn-xl btn-dark">
         App Store
        </a>
      </div>
    </section>



 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Software is a great combination between Artistry and Engineering..<i className="fa fa-check-circle fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://filepuma.com/" className="btn btn-xl btn-light mr-4">
         Filepuma
        </a>
        <a href="http://sourceforge.net/" className="btn btn-xl btn-dark">
       Sourceforge
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://macworld.com/" className="btn btn-xl btn-light mr-4">
         MacWorld
        </a>
        <a href="http://en.softonic.com/" className="btn btn-xl btn-dark">
          Softonic
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://downloads.zdnet.com/" className="btn btn-xl btn-light mr-4">
        ZDnet
        </a>
        <a href="http://download.com/" className="btn btn-xl btn-dark">
        Download
        </a>
      </div>
    </section>



     <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Innovation Distinguishes Between a Leader and a Follower..<i className="fa fa-check-circle fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.softpedia.com/" className="btn btn-xl btn-light mr-4">
       Softpedia
        </a>
        <a href="https://download.cnet.com/" className="btn btn-xl btn-dark">
        Download Cnet
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://opensourcemac.org/" className="btn btn-xl btn-light mr-4">
        Open Source Mac
        </a>
        <a href="https://tucows.com/" className="btn btn-xl btn-dark">
        Tucows
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://freedownloadscenter.com/mac/" className="btn btn-xl btn-light mr-4">
       Freedownloads Center
        </a>
        <a href="https://www.bytesin.com/" className="btn btn-xl btn-dark">
        Bytesin
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.snapfiles.com/" className="btn btn-xl btn-light mr-4">
        Snapfiles
        </a>
        <a href="https://www.freewarefiles.com/" className="btn btn-xl btn-dark">
        Freewarefiles
        </a>
      </div>
    </section>














    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
